import SpendingDemandListPresenter from "./SpendingDemandListPresenter";

const SpendingDemandList = SpendingDemandListPresenter

export default SpendingDemandList